export const ToolTipTexts = {
  NeedTooltipText:
    'This is calculated based on your minimum and maximum inventory levels. You can modify these values in Inventory reordering on an item page.',
  SuggestedPointTooltipText:
    'This is calculated using your average daily sales for each item and the average vendor lead time. It tells you when to place an order so you don’t run out.',
  SuggestedLevelTooltipText:
    "This is level of inventory you should have based on how much inventory you'll need to meet your forecasted demand.",
  SuggestedNeedTooltipText:
    'This is how much you should reorder to meet your suggested inventory level. It’s calculated using your sales history and forecast period, which you can set in Lightspeed Analytics.',
};
